import React, { useState, useEffect } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { Button, Box } from '@mui/material';
import MakeNextPayment from './MakeNextPayment';
import AvailableCartItemsForNextPayment from './AvailableCartItemsForNextPayment';
import BulkNextPaymentForm from './BulkNextPaymentForm';
import { Icon } from '@iconify/react';

const BulkNextPayment = ({ paidCartItems }) => {
  const [open, setOpen] = useState(false);
  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    if (paidCartItems?.length) {
      const filtered = paidCartItems.filter((item) => item.paymentCompletionStatus === 0);
      setAvailableItems(filtered);
    }
  }, [paidCartItems]);

  useEffect(() => {
    if (!open) {
      setFormData([]);
      setSelectedItems([]);
    }
  }, [open]);

  const handleClick = () => {
    setFormData(selectedItems);
    setSelectedItems([]);
  };

  return (
    <GlobalDialog
      title={'Cart Next Payment'}
      open={open}
      setOpen={setOpen}
      fullScreen
      closeButton={true}
      popupButton={
        <>
          <Button
            startIcon={<Icon icon="ix:document-bulk" width="20" height="20" />}
            size="small"
            onClick={() => setOpen(true)}
            variant="contained"
          >
            Bulk Next Payment
          </Button>
        </>
      }
      content={
        <Box p={2}>
          {open ? (
            <Box>
              {formData?.length > 0 ? (
                <BulkNextPaymentForm setOpen={setOpen} formData={formData} />
              ) : (
                <AvailableCartItemsForNextPayment
                  data={availableItems}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                />
              )}

              {selectedItems?.length > 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Button onClick={handleClick} variant="contained" size="small">
                    Proceed to next payment
                  </Button>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Box>
      }
    />
  );
};

export default BulkNextPayment;
